import React from "react";
import DoctorsProfileHero from "../sections/DoctorsProfileHero";
import Experience from "../sections/Experience";
import Comment from "../sections/Comment";
import Practise from "../sections/Practise";
import DoctorsContact from "../sections/DoctorsContact";

const Doctors = () => {
  return (
    <div>
      <DoctorsProfileHero />
      <Practise />
      <Experience />
      <Comment />
      <DoctorsContact />
    </div>
  );
};

export default Doctors;
